module.exports = __webpack_public_path__ + "img/logo-icon.e5f915c9.png";